/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardControllerDtoGetDashboardDataWalletData model module.
 * @module model/DashboardControllerDtoGetDashboardDataWalletData
 * @version 1.0
 */
class DashboardControllerDtoGetDashboardDataWalletData {
    /**
     * Constructs a new <code>DashboardControllerDtoGetDashboardDataWalletData</code>.
     * @alias module:model/DashboardControllerDtoGetDashboardDataWalletData
     */
    constructor() { 
        
        DashboardControllerDtoGetDashboardDataWalletData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardControllerDtoGetDashboardDataWalletData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardControllerDtoGetDashboardDataWalletData} obj Optional instance to populate.
     * @return {module:model/DashboardControllerDtoGetDashboardDataWalletData} The populated <code>DashboardControllerDtoGetDashboardDataWalletData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardControllerDtoGetDashboardDataWalletData();

            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Date');
            }
            if (data.hasOwnProperty('hvhBalance')) {
                obj['hvhBalance'] = ApiClient.convertToType(data['hvhBalance'], 'Number');
            }
            if (data.hasOwnProperty('perBalance')) {
                obj['perBalance'] = ApiClient.convertToType(data['perBalance'], 'Number');
            }
            if (data.hasOwnProperty('xperBalance')) {
                obj['xperBalance'] = ApiClient.convertToType(data['xperBalance'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardControllerDtoGetDashboardDataWalletData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardControllerDtoGetDashboardDataWalletData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} timestamp
 */
DashboardControllerDtoGetDashboardDataWalletData.prototype['timestamp'] = undefined;

/**
 * @member {Number} hvhBalance
 */
DashboardControllerDtoGetDashboardDataWalletData.prototype['hvhBalance'] = undefined;

/**
 * @member {Number} perBalance
 */
DashboardControllerDtoGetDashboardDataWalletData.prototype['perBalance'] = undefined;

/**
 * @member {Number} xperBalance
 */
DashboardControllerDtoGetDashboardDataWalletData.prototype['xperBalance'] = undefined;






export default DashboardControllerDtoGetDashboardDataWalletData;

